<template>
  <div>
    <DialogContainer v-model="dialogObj">
      <template v-slot:dialogSlot>
        <div class="config-box">
          <el-form
            ref="form"
            :model="form"
            class="form custom-form"
            :rules="rulesFour"
            label-position="top"
          >
            <el-form-item label="旧密码" prop="password">
              <el-input
                v-model="form.password"
                clearable
                style="width: 100%"
                type="password"
                show-password
                autocomplete="off"
                placeholder="请输入原密码"
                maxlength="30"
              />
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input
                v-model="form.newPassword"
                clearable
                style="width: 100%"
                type="password"
                autocomplete="off"
                show-password
                placeholder="请输入新密码"
                maxlength="30"
              />
            </el-form-item>
            <el-form-item label="确认新密码" prop="recheckNewPassword">
              <el-input
                v-model="form.recheckNewPassword"
                clearable
                style="width: 100%"
                type="password"
                show-password
                autocomplete="off"
                placeholder="请输入确认新密码"
                maxlength="30"
              />
            </el-form-item>
            <el-form-item label-width="0"
              ><span @click="forgetPass()">忘记原密码</span>?</el-form-item
            >
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button type="default" @click.stop="handleCancel()">取消</el-button>
        <el-button
          type="primary"
          @click.stop="submitForm()"
          :loading="dialogObj.btnLoading"
          >确认</el-button
        >
      </template>
    </DialogContainer>
    <update-password2 ref="updatePassword2"></update-password2>
  </div>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import updatePassword2 from "./updatePassword2.vue";
import { updatePassword } from "../api";
export default {
  name: "UpdatePassword",
  components: {
    DialogContainer,
    updatePassword2,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.form.recheckPassword !== "") {
        this.$refs.form.validateField("recheckPassword");
      }
      callback();
    };
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error("两次输入的新密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      phone: "",
      isDisabled: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "修改密码",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          this.isDisabled = false;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      // 账号配置
      form: {
        password: "",
        newPassword: "",
        recheckNewPassword: "",
      },
      rulesFour: {
        password: [
          { required: true, message: "请输入原密码" },
          // { validator: validateIdAccount, trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码" },
          { validator: validatePass, trigger: "blur" },
        ],
        recheckNewPassword: [
          { required: true, message: "请确认新密码" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    forgetPass() {
      this.$refs.updatePassword2.init(this.phone);
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let par = {
            oldPwd: this.form.password,
            newPwd: this.form.newPassword,
          };
          updatePassword(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("修改成功");
                setTimeout(() => {
                  localStorage.clear();
                  this.$router.replace({ name: "Login" });
                }, 300);
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    handleCancel() {
      this.dialogObj.beforeClose();
    },
    handleClick() {},
    init(phone) {
      this.phone = phone;
      this.dialogObj.show = true;
    },
  },
};
</script>
<style lang="scss">
.custom-form {
  .second-form {
    .form-two-box {
      .el-checkbox__label {
        color: #718096;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.config-box {
  padding: 0 0.2rem 0;
  //min-height: rem;
  .third-form {
    .form-one {
      padding-left: 0.1rem;
    }
    .form-two {
      padding-left: 0.9rem;
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
    }
  }
  .second-form {
    .form-one {
      padding-left: 0.1rem;
    }
    .form-two {
      display: flex;
      padding-left: 0.9rem;
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
      flex-wrap: wrap;
      .form-two-box {
        width: 2rem;
        padding: 0.1rem 0;
      }
    }
  }
}
</style>
